export const STATUS_COLORS = {
  COMPLETED: "#1B365D", // Brand primary navy
  INCOMPLETE: "#B08D57", // Muted warm gold
};
